<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">
                    {{ (Array.isArray(data) ? data.length > 0 : Object.keys(data).length > 0) ? 'Modifier' : 'Créer' }} une
                    formule
                </h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-11">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-lg-6 col-md-12">
                                    <div class="form-group">
                                        <label for="name" class="form-label">Nom<span class="text-purple">*</span></label>
                                        <input
                                            id="name"
                                            v-model="pack.name"
                                            class="form-control"
                                            placeholder="Nom du pack"
                                            required
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-12">
                                    <div class="form-group">
                                        <label for="origin" class="form-label">Origine produit</label>
                                        <input id="origin" v-model="pack.origin" class="form-control" placeholder="Origine" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <!-- sur place start -->
                                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4">
                                    Tarif sur place (obligatoire)
                                </h3>

                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="vat_rate"
                                        >Taux de TVA (en %)<span class="text-purple">*</span></label
                                    >
                                    <div class="input-group rounded-24">
                                        <select
                                            v-model="pack.vat_rate"
                                            class="form-select form-control"
                                            @change="calculatePriceHT()"
                                            required
                                        >
                                            <option v-for="vat in country_vat_rates" :key="vat.id" :value="vat.pourcentage">
                                                {{ vat.pourcentage }} - {{ vat.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="price"
                                        >Prix de vente TTC (en {{ $symbolCurrency }})<span class="text-purple">*</span></label
                                    >
                                    <div class="input-group rounded-24">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price"
                                            :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePrice()"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-lg-4 col-md-12">
                                    <label class="form-label" for="price_ht"
                                        >Prix HT (en {{ $symbolCurrency }})<span class="text-purple">*</span></label
                                    >
                                    <div class="input-group rounded-24 ">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price_ht"
                                            :placeholder="$placeholderText('Prix HT    (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePriceHT()"
                                        />
                                    </div>
                                </div> -->
                            </div>

                            <div class="col-12 mt-2">
                                <h6 class="fs-6 fw-medium ppv2-text-black pt-1 mt-2">Disponible à emporter ? (Oui/Non)</h6>
                                <div class="form-check form-switch" style="padding-left: 0">
                                    <input
                                        type="checkbox"
                                        v-model="pack.is_active_takeaway"
                                        class="form-control form-check-input"
                                        @change="handleIsActiveTakeawayChange($event)"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="pack.is_active_takeaway">
                                <!-- takeaway start -->
                                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4 mb-4">
                                    Tarif à emporter (facultatif)
                                </h3>
                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="vat_rate_takeaway">Taux de TVA (en %)</label>
                                    <div class="input-group rounded-24">
                                        <select
                                            v-model="pack.vat_rate_takeaway"
                                            class="form-select form-control"
                                            @change="calculatePriceHTTakeaway()"
                                            required
                                        >
                                            <option v-for="vat in country_vat_rates" :key="vat.id" :value="vat.pourcentage">
                                                {{ vat.pourcentage }} - {{ vat.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="price_takeaway"
                                        >Prix de vente TTC (en {{ $symbolCurrency }})</label
                                    >
                                    <div class="input-group rounded-24">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price_takeaway"
                                            :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePriceTakeaway()"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-lg-4 col-md-12">
                                    <label class="form-label" for="price_ht_takeaway">Prix HT (en {{ $symbolCurrency }})</label>
                                    <div class="input-group rounded-24 ">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price_ht_takeaway"
                                            :placeholder="$placeholderText('Prix HT    (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePriceHTTakeaway()"
                                        />
                                    </div>
                                </div> -->
                            </div>

                            <div class="col-12 mt-2">
                                <h6 class="fs-6 fw-medium ppv2-text-black pt-1 mt-2">Disponible en livraison ? (Oui/Non)</h6>
                                <div class="form-check form-switch" style="padding-left: 0">
                                    <input
                                        type="checkbox"
                                        v-model="pack.is_active_delivery"
                                        class="form-control form-check-input"
                                        @change="handleIsActiveDeliveryChange($event)"
                                    />
                                </div>
                            </div>

                            <div class="row" v-if="pack.is_active_delivery">
                                <!-- delivery start -->
                                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4 mb-4">
                                    Livraison (facultatif)
                                </h3>

                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="vat_rate_delivery">Taux de TVA (en %)</label>
                                    <div class="input-group rounded-24">
                                        <select
                                            v-model="pack.vat_rate_delivery"
                                            class="form-select form-control"
                                            @change="calculatePriceHTDelivery()"
                                            required
                                        >
                                            <option v-for="vat in country_vat_rates" :key="vat.id" :value="vat.pourcentage">
                                                {{ vat.pourcentage }} - {{ vat.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-12">
                                    <label class="form-label" for="price_delivery"
                                        >Prix de vente TTC (en {{ $symbolCurrency }})</label
                                    >
                                    <div class="input-group rounded-24">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price_delivery"
                                            :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePriceDelivery()"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-lg-4 col-md-12">
                                    <label class="form-label" for="price_ht_delivery">Prix HT (en {{ $symbolCurrency }})</label>
                                    <div class="input-group rounded-24 ">
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="pack.price_ht_delivery"
                                            :placeholder="$placeholderText('Prix HT    (en ', $symbolCurrency, ')')"
                                            required
                                            @input="calculatePriceHTDelivery()"
                                        />
                                    </div>
                                </div> -->
                            </div>
                            <div class="row">
                                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4">
                                    Composez votre formule
                                </h3>
                                <div class="col-lg-12 col-xs-12 mt-4">
                                    <div
                                        class="row mb-3"
                                        :class="{ 'even-background': isEven(index), 'odd-background': !isEven(index) }"
                                        v-for="(item, index) in pack.items"
                                        :key="index"
                                    >
                                        <div class="col-10">
                                            <div class="form-group">
                                                <label :for="'name' + item" class="form-label"
                                                    >Nom<span class="text-purple">*</span></label
                                                >
                                                <input
                                                    :id="'name' + item"
                                                    v-model="item.name"
                                                    class="form-control"
                                                    placeholder="Nom"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div class="col-2">
                                            <button type="button" class="btn btn-minuss mt-5 mt-resp" @click="deleteItem(index)">
                                                -
                                            </button>
                                        </div>

                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="selectFoodMenu" class="form-label"
                                                    >Option(s)<span class="text-purple">*</span></label
                                                >
                                                <v-select
                                                    class="v-select"
                                                    id="selectFoodMenu"
                                                    v-model="item.food"
                                                    :options="listFoods"
                                                    label="name"
                                                    :placeholder="'Option(s) '"
                                                    multiple
                                                    hide-selected
                                                    :get-option-label="(option) => option.name"
                                                    @input="(food) => updateSelectedFood(item, food)"
                                                >
                                                    <template #option="option">
                                                        {{ option.name }} - [Sur place: {{ formatPriceWithSymbol(option.price) }}]
                                                        <span
                                                            v-if="option.price_takeaway != null && option.price_takeaway !== ''"
                                                        >
                                                            - [Importer: {{ formatPriceWithSymbol(option.price_takeaway) }}]
                                                        </span>
                                                    </template>
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            Aucun résultat trouvé pour <em>{{ search }}</em
                                                            >.
                                                        </template>
                                                        <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>

                                        <hr />
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button
                                            type="button"
                                            class="btn btn fs-sm btn-dark fw-medium py-0 px-4 rounded-12"
                                            style="height: 43px !important"
                                            @click="addItem"
                                        >
                                            Ajouter une option
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="imageUpload" class="form-label">Image du produit</label>
                                        <div class="form-control overflow-hidden text-center new-image desg_new_img">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="29"
                                                height="24"
                                                viewBox="0 0 29 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                                    stroke="#021832"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M9.99988 15L13.9999 11L17.9999 15"
                                                    stroke="#021832"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M13.9999 11V23"
                                                    stroke="#021832"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <label class="form-control text-center" id="file-label" for="imageUpload"
                                                >Télécharger une image</label
                                            >
                                            <input
                                                type="file"
                                                id="imageUpload"
                                                @change="handleImageUpload"
                                                class="form-control d-none"
                                            />
                                            <div v-if="pack.image" class="mt-3">
                                                <img :src="pack.image" alt="Carte image" class="img-thumbnail" width="300" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mt-4 flex-wrap px-6 gap-40 pt-2">
                                <a
                                    href="/back-office/food/pack"
                                    class="btn btn-outline-dark height_btn_page line_height41 rounded-12 fw-semibold width-btn"
                                >
                                    Annuler
                                </a>
                                <button type="submit" class="btn btn-dark height_btn_page rounded-12 fw-semibold width-btn">
                                    {{ Object.keys(this.data).length === 0 ? 'Ajouter' : 'Mettre à jour' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ApiManager from '../Api/ApiManagerFood.js'

export default {
    props: ['data', 'country_vat_rates'],
    data() {
        return {
            pack: {
                name: '',
                origin: '',
                subtitle: '',
                description: '',
                seo_description: '',
                seo_title: '',
                seo_keywords: '',
                short_description: '',
                image: '',
                price: '',
                price_ht: '',
                vat_rate: 0,
                price_takeaway: '',
                price_ht_takeaway: '',
                vat_rate_takeaway: 0,
                price_delivery: '',
                price_ht_delivery: '',
                vat_rate_delivery: 0,
                items: [],
                is_active_takeaway: false,
                is_active_delivery: false,
            },
            kitchens: [],
            foods: [],
        }
    },

    computed: {
        listFoods() {
            return this.foods
        },
        listKitchens() {
            return this.kitchens
        },
    },

    methods: {
        formatPriceWithSymbol(price, decimal = 2) {
            if (price == null || price == '') return '--.--'
            const num = parseFloat(price)
            if (isNaN(num)) return '--.--'
            return `${num.toFixed(decimal)} ${this.$symbolCurrency}`
        },

        formatPrice(price, decimal = 2) {
            if (price == null || price == '') return null
            const num = parseFloat(price)
            if (isNaN(num)) return null
            return `${num.toFixed(decimal)}`
        },

        isEven(index) {
            return index % 2 === 0
        },

        addItem() {
            this.pack.items.push({
                name: '',
                food: null,
                active: true,
            })
        },

        deleteItem(index) {
            this.pack.items.splice(index, 1)
        },

        updateSelectedFood(item, food) {
            item.food = food
        },

        calculatePrice() {
            const price = parseFloat(this.pack.price) || 0
            const vatRate = parseFloat(this.pack.vat_rate) || 0

            this.pack.price_ht = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimal)
        },

        calculatePriceHT() {
            const priceHT = parseFloat(this.pack.price_ht) || 0
            const vatRate = parseFloat(this.pack.vat_rate) || 0

            this.pack.price = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        calculatePriceTakeaway() {
            const price = parseFloat(this.pack.price_takeaway) || 0
            const vatRate = parseFloat(this.pack.vat_rate_takeaway) || 0

            this.pack.price_ht_takeaway = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimal)
        },

        calculatePriceHTTakeaway() {
            const priceHT = parseFloat(this.pack.price_ht_takeaway) || 0
            const vatRate = parseFloat(this.pack.vat_rate_takeaway) || 0

            this.pack.price_takeaway = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        calculatePriceDelivery() {
            const price = parseFloat(this.pack.price_delivery) || 0
            const vatRate = parseFloat(this.pack.vat_rate_delivery) || 0

            this.pack.price_ht_delivery = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimal)
        },

        calculatePriceHTDelivery() {
            const priceHT = parseFloat(this.pack.price_ht_delivery) || 0
            const vatRate = parseFloat(this.pack.vat_rate_delivery) || 0

            this.pack.price_delivery = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        handleIsActiveTakeawayChange(event) {
            if (!event.target.checked) {
                this.pack.price_takeaway = ''
                this.pack.price_ht_takeaway = ''
                this.pack.vat_rate_takeaway = 0
            }
            this.$forceUpdate()
        },

        handleIsActiveDeliveryChange(event) {
            if (!event.target.checked) {
                this.pack.price_delivery = ''
                this.pack.price_ht_delivery = ''
                this.pack.vat_rate_delivery = 0
            }
            this.$forceUpdate()
        },

        handleSubmit() {
            if (Object.keys(this.data).length !== 0) {
                this.updatePack()
            } else {
                this.storePack()
            }
        },

        storePack() {
            axios
                .post('/back-office/food/pack', this.pack)
                .then((response) => {
                    console.log('pack created:', response.data)
                    window.location.href = '/back-office/food/pack/'
                    this.$toast.success(this.$t('food.packs.created_success'))
                })
                .catch((error) => {
                    console.error('Error creating pack:', error)
                    this.showErrors(error)
                })
        },

        updatePack() {
            const packId = this.data.id

            axios
                .put(`/back-office/food/pack/${packId}`, this.pack)
                .then((response) => {
                    console.log('updated:', response.data)
                    this.$toast.success(this.$t('food.packs.updated_success'))
                })
                .catch((error) => {
                    console.error('Error updating pack:', error)
                    this.showErrors(error)
                })
        },

        async fetchFoods() {
            try {
                const params = new URLSearchParams({
                    categories: [this.slug].join(','),
                    select: ['id', 'slug', 'name', 'price', 'price_ht', 'price_takeaway', 'price_ht_takeaway'],
                    groupBy: [],
                })
                const data = await ApiManager.fetchFood(params)
                this.foods = data.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        showErrors(response) {
            console.log('response', response)
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors

                console.log('errors', errors)

                for (const key in errors) {
                    const errorMessage = errors[key][0]

                    console.log('errorMessage', errorMessage)

                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },

        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.pack.image = e.target.result
                }
                reader.readAsDataURL(file)
            }
        },
    },

    mounted() {
        if (Object.keys(this.data).length !== 0) {
            this.pack = { ...this.data }

            this.pack.price = this.formatPrice(this.pack?.price || 0, this.$priceDecimal)
            this.pack.price_takeaway = this.formatPrice(this.pack?.price_takeaway || 0, this.$priceDecimal)
            this.pack.price_delivery = this.formatPrice(this.pack?.price_delivery || 0, this.$priceDecimal)

            const priceTakeaway = parseFloat(this.pack.price_takeaway) || 0
            this.pack.is_active_takeaway = priceTakeaway > 0

            const priceDelivery = parseFloat(this.pack.price_delivery) || 0
            this.pack.is_active_delivery = priceDelivery > 0

            this.pack.category_id = {
                id: this.data?.category?.id,
                name: this.data?.category?.name,
            }

            this.pack.kitchen_id = {
                id: this.data?.kitchen?.id,
                name: this.data?.kitchen?.name,
            }
        }
        // this.fetchMenus()
        this.fetchFoods()
    },

    components: {
        vSelect,
    },
}
</script>

<style lang="scss">
#selectFoodMenu .vs__dropdown-toggle,
#kitchen .vs__dropdown-toggle {
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    min-height: 56px;
}

.odd-background {
    background-color: #7d2dbd70;
    border-radius: 8px;
}

.even-background {
    background-color: #02183212;
    border-radius: 8px;
}
</style>
